import { FC, JSX } from "react";
import { ScrollView } from "react-native";
import { IGetCurrentUserResponse } from "@/_store/currentUser/contracts";
import IndividualCheckForm from "@/app/(main)/general/individualCheck/IndividualCheckForm";

interface IIndividualCheckProps {
  subscribeData: IGetCurrentUserResponse | undefined;
}

const IndividualCheck: FC<IIndividualCheckProps> = ({ subscribeData }): JSX.Element => {
  const totalReports: number = subscribeData?.subscription?.total_reports ?? 0;

  return (
    <ScrollView className="flex-1 p-5">
      <IndividualCheckForm totalReports={totalReports} />
    </ScrollView>
  );
};

export default IndividualCheck;
